import Vue from 'vue';

export default {
  namespaced: true,

  // initial state
  state: {
    items: [],
  },

  // getters
  getters: {
    getItems(state) {
      return state.items;
    },
    getError(state) {
      return state.error;
    },
  },

  // actions
  actions: {
    loadItems({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(`/attendance`, { params: params })
          .then((response) => {
            if (response.status == 200) {
              commit('setItems', response.data.results);
              resolve(response);
            }
          })
          .catch((error) => reject(error));
      });
    },
    appendItems({ commit }, params) {
      Vue.axios.get(`/attendance-tracking`, { params: params })
        .then((response) => commit('appendItems', response.data));
    },
  },

  // mutations
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    appendItems(state, items) {
      state.items = state.items.concat(items);
    },
  },
};
